/** 受注確定時にサーバと管理画面で共通利用する必須項目。 */
export interface ConfirmableOrderFields {
  store_address: string | null;
  delivery_address: string | null;
  payment_type: string | null;
  items: readonly unknown[];
}

const isBlank = (value: string | null | undefined): boolean =>
  value == null || value.trim().length === 0;

/** 確定に必要な項目のうち、不足している項目の日本語ラベルを返す。 */
export function collectMissingConfirmationFields(order: ConfirmableOrderFields): string[] {
  const missing: string[] = [];
  if (isBlank(order.store_address)) missing.push("集荷先住所");
  if (isBlank(order.delivery_address)) missing.push("配送先住所");
  if (isBlank(order.payment_type)) missing.push("支払方法");
  if (order.items.length === 0) missing.push("商品明細");
  return missing;
}
